export default "__VITE_ASSET__UuVR7uNf__"